export enum OnIssueVo {
  /** 완결 */
  End = 'N',
  /** 연재중 */
  Ing = 'Y',
  /** 휴재중*/
  Pause = 'P',

  /**
   * XXX: 휴재중. P대신 R로 넘어오는 경우가 있어서 추가했습니다. 니콜라스 코드에서는 on_issue R을 휴재중으로 사용하고 있습니다.
   * API문서에 문의를 남겨놓은 상태라서 추후 변경이 필요할 수 있습니다. https://podotree.atlassian.net/wiki/spaces/PSD/pages/2791637757?focusedCommentId=2883880739#comment-2883880739
   */
  PauseLegacy = 'R',
}
